import axios from 'axios';
import { warning, error } from '../services/alert';
import {getToken} from './user';
import { appConfig } from './config'
import { useAuth } from '../contexts/auth';

const token = getToken()


//export const urlBackend = 'https://automotorista-api-hmg.aguiabranca.com.br/api-backoffice/api' 

//export const urlBackend = process.env.REACT_APP_URL_API;
//export const urlBackend = appConfig.REACT_APP_URL_API;

export const urlBackend = appConfig.urlApi;

const api = axios.create({
  baseURL: urlBackend,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    'Access-Control-Allow-Origin': '*',
    Authorization: `Bearer ${token}`
  },
});


api.interceptors.response.use(
  (response) => {
   
    // Responsavel por verificar se existe erro dentro do response
    const { data } = response;
    //console.log(data)
    if (data.hasError) {
        for (const key in data.errors) {
        if (data.errors.hasOwnProperty(key)) {
          warning(data.errors[key]);
        }
      }
    }

    if (!data.success) {
      if (data.object) {
        for (const key in data.object) {
          if (data.object.hasOwnProperty(key)) {
            const { errorMessage } = data.object[key];
            warning(errorMessage);
          }
        }
      } else {
        warning(data.message);
      }
    }

    if (data.result?.hasError) {
      for (const key in data.result.errors) {
        if (data.result.errors.hasOwnProperty(key)) {
          warning(data.result.errors[key]);
        }
      }
    }
 
    return response;
  },  
  (erro) => {

    if (erro.response?.status === 401) {
      const requestConfig = erro.config;
      localStorage.clear();
      document.location.reload(true);
      return axios(requestConfig);
    }else{

      error("Ops! Ocorreu um problema. Entre em contato com o administrador do sistema!");
    } 
    return Promise.reject(erro);
  }
);


export default api;
